export const API_TYPES = {
  AUTH: "auth",
  UNOS: "unosRad",
};

export const API_APP_NAMES = {
  UNOS: "express_unos",
};
